import { createApp } from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import axios from 'axios'
import '@/App.css' 
import PrimeVue from 'primevue/config';    
import 'primevue/resources/themes/aura-light-green/theme.css'
import 'primeicons/primeicons.css'
import ToastService from 'primevue/toastservice';
import ConfirmationService from 'primevue/confirmationservice'; 
import Tooltip from 'primevue/tooltip'
import { env } from "@/composables/config";
import { watch } from 'vue';
import { cookieChoice, optionalAllowed } from '@/composables/cookieConsent';
import { createOptionalScripts } from '@/services/optionalScripts.mjs';
import { loadTranslations } from "@/composables/translate";

async function bootstrap() {
    await loadTranslations();

    const app = createApp(App)
    app.use(ToastService);
    app.use(ConfirmationService);
    app.use(PrimeVue, {
        ripple: true
    })
    app.use(store)
    const optionalScripts = createOptionalScripts({ win: window, doc: document,
        analyticsId: env('APP_GOOGLE_ANALYTICS_ID'), supportProperty: env('APP_TAWKTO_SECRET'), supportWidget: env('APP_TAWKTO_ID') });
    watch(cookieChoice, () => optionalScripts.apply({ analytics: optionalAllowed('analytics'), support: optionalAllowed('support') }), { immediate: true });
    router.afterEach(() => { if (optionalAllowed('analytics')) optionalScripts.pageView(); });
    app.use(router)
    app.config.globalProperties.$axios = axios
    app.directive('tooltip', Tooltip);
    app.mount('#app')
}

bootstrap();
